import {
  hasAnyRole,
  hatFrueherkennungProgramm,
  IGesundheitsProgrammInfo,
  isApiAbschlussPartner,
  isCodePruefungPartner,
  isFitnessOrYogaPartner,
  isHotelPartner,
  isMgsAdmin,
  isMgsBuchungszentraleUser,
  isMgsFalldatenUser,
  isMgsSuperAdmin,
  IUser,
  MgsRole,
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_ADMIN,
  ROLE_MGS_KIDS,
  ROLE_MGS_SUPER_ADMIN,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';
import { createObjectArrayFromArray } from '@mng/mng-ts-helpers';
import {
  MGS_CALENDAR_ICON,
  MGS_CHECKED_ICON,
  MGS_CONTACT_ICON,
  MGS_COUNTER_ICON,
  MGS_CURRENCY_ICON,
  MGS_DIENSTLEISTUNG_ICON,
  MGS_DOCUMENT_ICON,
  MGS_FAQ_ICON,
  MGS_HOTEL_ICON,
  MGS_LABOR_ICON,
  MGS_TOOLS_ICON,
  MGS_USER_GROUP_ICON
} from '../mgs-svg-icon.helper';
import { Injector } from '@angular/core';
import { KidsBuchungInfoService } from '../kids-buchung/kids-buchung-info/kids-buchung-info.service';
import {
  ADMIN_SERVICES_PATH,
  AUDITLOG_PATH,
  AUDITLOG_TITLE,
  CODE_PRUEFUNG_PATH,
  CODE_PRUEFUNG_TITLE,
  DEMO_PATH,
  DEMO_TITLE,
  DIENSTLEISTUNG_ERFASSUNG_PATH,
  DIENSTLEISTUNG_ERFASSUNG_TITLE,
  DIENSTLEISTUNG_PATH,
  DIENSTLEISTUNG_SCHNELLABSCHLUSS_PATH,
  DIENSTLEISTUNG_SCHNELLABSCHLUSS_TITLE,
  DIENSTLEISTUNG_TITLE,
  DIENSTLEISTUNGEN_PATH,
  DIENSTLEISTUNGEN_TITLE,
  DOKUMENTE_PATH,
  DOKUMENTE_TITLE,
  FALLPARTNERDETAIL_PATH,
  FALLPARTNERDETAIL_TITLE,
  KIDS_HOTELS_PATH,
  KIDS_HOTELS_TITLE,
  KIDS_IMPORT_PATH,
  KIDS_IMPORT_TITLE,
  KIDS_PATH,
  KIDS_TERMINE_PATH,
  KIDS_TERMINE_TITLE,
  KIDS_TITLE,
  KUNDEN_PATH,
  KUNDEN_TITLE,
  LABOR_PROTOKOLL_PATH,
  LABOR_PROTOKOLL_TITLE,
  LEISTUNG_ABRECHNUNGEN_PATH,
  LEISTUNG_ABRECHNUNGEN_TITLE,
  LEISTUNG_DEF_PATH,
  LEISTUNG_DEF_TITLE,
  LEISTUNG_IMPORTER_PATH,
  LEISTUNG_IMPORTER_TITLE,
  LEISTUNG_PATH,
  LEISTUNG_TITLE,
  PARTNER_PATH,
  PARTNER_TITLE,
  PROGRAMME_PATH,
  PROGRAMME_TITLE,
  USER_LIST_PATH,
  USER_LIST_TITLE
} from '../mgs-path-defs';
import { dienstleistungDemoRolesForExclusion } from '../dienstleistung/dienstleistung-demo/dienstleistung-demo.route';
import { dienstleistungListRolesForExclusion } from '../dienstleistung/dienstleistung-list/dienstleistung-list.route';
import { dienstleistungLadenRolesForExclusion } from '../dienstleistung/dienstleistung-laden/dienstleistung-laden.route';
import { dienstleistungSchnellabschlussRolesForExclusion } from '../dienstleistung/dienstleistung-schnellabschluss/dienstleistung-schnellabschluss.route';
import { dienstleistungErfassungRolesForExclusion } from '../dienstleistung/dienstleistung-erfassung/dienstleistung-erfassung.route';
import { leistungRolesForExclusion } from '../leistung/leistung/leistung.route';
import { abrechnungenRolesForExclusion } from '../leistung/abrechnungen/abrechnungen.route';
import { leistungdefRolesForExclusion } from '../leistung/leistungdef-list/leistungdef.route';
import { leistungImporterRolesForExclusion } from '../leistung/leistung-importer/leistung-importer.route';
import { fallpartnerDetailRolesForExclusion } from '../fall/fallpartnerdetail/fallpartnerdetail.route';
import { codePruefungRolesForExclusion } from '../dienstleistung/code-pruefung/code-pruefung.route';
import { laborRolesForExclusion } from '../labor/labor-protokoll/labor-protokoll.route';

export type MgsUiGroup = 'Dienstleistung' | 'Leistung' | 'Falldaten' | 'Admin' | 'Kids' | 'Sonstiges';

export interface IActionItem {
  label: string;
  route?: string;
  action?: (injector: Injector) => void;
  svgIcon?: string;
  roles?: MgsRole[];
  rolesForExclusion?: MgsRole[];
  group?: MgsUiGroup;
  visibleFunc?: (context: IActionContext) => boolean;
}

export const codePruefungItem: IActionItem = {
  label: CODE_PRUEFUNG_TITLE,
  route: CODE_PRUEFUNG_PATH,
  rolesForExclusion: codePruefungRolesForExclusion,
  svgIcon: MGS_CHECKED_ICON,
  group: 'Dienstleistung',
  visibleFunc: ({ user, userRoles, programme }: IActionContext) =>
    (user.partner && isCodePruefungPartner(user.partner, programme)) ||
    isMgsAdmin(userRoles) ||
    isMgsBuchungszentraleUser(userRoles)
};

export const dokumenteItem: IActionItem = {
  label: DOKUMENTE_TITLE,
  route: DOKUMENTE_PATH,
  svgIcon: MGS_DOCUMENT_ICON,
  group: 'Sonstiges',
  rolesForExclusion: [ROLE_MGS_ABRECHNUNG],
  visibleFunc: ({ user, programme }: IActionContext) =>
    user.partner && !isFitnessOrYogaPartner(user.partner) && !isApiAbschlussPartner(programme)
};

export const kundeListItem: IActionItem = {
  label: KUNDEN_TITLE,
  route: KUNDEN_PATH,
  rolesForExclusion: [ROLE_MGS_KIDS, ROLE_MGS_USER_FOR_KIDS_TERMIN],
  svgIcon: MGS_USER_GROUP_ICON,
  group: 'Admin',
  roles: [ROLE_MGS_ADMIN]
};

export const demoItem: IActionItem = {
  label: DEMO_TITLE,
  route: DEMO_PATH,
  svgIcon: MGS_DIENSTLEISTUNG_ICON,
  group: 'Sonstiges',
  rolesForExclusion: dienstleistungDemoRolesForExclusion,
  visibleFunc: (context: IActionContext) => context.demoProgramme?.length > 0
};

export const dienstleistungListItem: IActionItem = {
  label: DIENSTLEISTUNGEN_TITLE,
  route: DIENSTLEISTUNGEN_PATH,
  svgIcon: MGS_DIENSTLEISTUNG_ICON,
  group: 'Dienstleistung',
  rolesForExclusion: dienstleistungListRolesForExclusion
};

export const dienstleistungItem: IActionItem = {
  label: DIENSTLEISTUNG_TITLE,
  route: DIENSTLEISTUNG_PATH,
  svgIcon: MGS_DIENSTLEISTUNG_ICON,
  group: 'Dienstleistung',
  rolesForExclusion: dienstleistungLadenRolesForExclusion,
  visibleFunc: (context: IActionContext) => !isApiAbschlussPartner(context.programme)
};

export const dienstleistungSchnellAbschlussItem: IActionItem = {
  label: DIENSTLEISTUNG_SCHNELLABSCHLUSS_TITLE,
  route: DIENSTLEISTUNG_SCHNELLABSCHLUSS_PATH,
  svgIcon: MGS_DIENSTLEISTUNG_ICON,
  group: 'Dienstleistung',
  rolesForExclusion: dienstleistungSchnellabschlussRolesForExclusion,
  visibleFunc: ({ user, userRoles }: IActionContext) =>
    (user.partner && isHotelPartner(user.partner)) || isMgsAdmin(userRoles)
};

export const dienstleistungDatenerfassungItem: IActionItem = {
  label: DIENSTLEISTUNG_ERFASSUNG_TITLE,
  route: '/' + DIENSTLEISTUNG_ERFASSUNG_PATH,
  svgIcon: MGS_DIENSTLEISTUNG_ICON,
  group: 'Dienstleistung',
  roles: [ROLE_MGS_ADMIN],
  rolesForExclusion: dienstleistungErfassungRolesForExclusion
};

export const adminServicesItem: IActionItem = {
  label: 'Admin Services',
  route: ADMIN_SERVICES_PATH,
  svgIcon: MGS_TOOLS_ICON,
  group: 'Admin',
  roles: [ROLE_MGS_ADMIN],
  rolesForExclusion: [ROLE_MGS_KIDS]
};

export const auditlogServicesItem: IActionItem = {
  label: AUDITLOG_TITLE,
  route: AUDITLOG_PATH,
  svgIcon: MGS_TOOLS_ICON,
  group: 'Admin',
  roles: [ROLE_MGS_SUPER_ADMIN]
};

export const partnerItem: IActionItem = {
  label: PARTNER_TITLE,
  route: '/' + PARTNER_PATH,
  svgIcon: MGS_USER_GROUP_ICON,
  group: 'Admin',
  rolesForExclusion: [ROLE_MGS_KIDS],
  roles: [ROLE_MGS_ADMIN]
};

export const userListItem: IActionItem = {
  label: USER_LIST_TITLE,
  route: '/' + USER_LIST_PATH,
  svgIcon: MGS_USER_GROUP_ICON,
  group: 'Admin',
  rolesForExclusion: [ROLE_MGS_KIDS],
  roles: [ROLE_MGS_ADMIN]
};

export const programmeItem: IActionItem = {
  label: PROGRAMME_TITLE,
  route: '/' + PROGRAMME_PATH,
  svgIcon: MGS_DOCUMENT_ICON,
  group: 'Admin',
  rolesForExclusion: [ROLE_MGS_KIDS],
  roles: [ROLE_MGS_ADMIN]
};

export const leistungItem: IActionItem = {
  label: LEISTUNG_TITLE,
  route: '/' + LEISTUNG_PATH,
  svgIcon: MGS_CURRENCY_ICON,
  rolesForExclusion: [...leistungRolesForExclusion, ROLE_MGS_ABRECHNUNG],
  group: 'Leistung',
  visibleFunc: ({ user }: IActionContext) => !user.istArzt
};

export const abrechnungenItem: IActionItem = {
  label: LEISTUNG_ABRECHNUNGEN_TITLE,
  route: '/' + LEISTUNG_ABRECHNUNGEN_PATH,
  svgIcon: MGS_CURRENCY_ICON,
  group: 'Leistung',
  rolesForExclusion: abrechnungenRolesForExclusion,
  visibleFunc: ({ user }: IActionContext) => !user.istArzt
};

export const leistungdefItem: IActionItem = {
  label: LEISTUNG_DEF_TITLE,
  route: '/' + LEISTUNG_DEF_PATH,
  svgIcon: MGS_CURRENCY_ICON,
  group: 'Leistung',
  rolesForExclusion: leistungdefRolesForExclusion,
  roles: [ROLE_MGS_ADMIN]
};

export const leistungImporterItem: IActionItem = {
  label: LEISTUNG_IMPORTER_TITLE,
  route: '/' + LEISTUNG_IMPORTER_PATH,
  svgIcon: MGS_CURRENCY_ICON,
  group: 'Leistung',
  rolesForExclusion: leistungImporterRolesForExclusion,
  roles: [ROLE_MGS_ADMIN]
};

export const fallPartnerDetailItem: IActionItem = {
  label: FALLPARTNERDETAIL_TITLE,
  route: '/' + FALLPARTNERDETAIL_PATH,
  svgIcon: MGS_COUNTER_ICON,
  rolesForExclusion: fallpartnerDetailRolesForExclusion,
  group: 'Falldaten',
  visibleFunc: ({ user, userRoles, programme }: IActionContext) => {
    return (
      (user.partner && isHotelPartner(user.partner)) ||
      hatFrueherkennungProgramm(programme) ||
      (isMgsAdmin(userRoles) && isMgsFalldatenUser(userRoles)) ||
      isMgsSuperAdmin(userRoles)
    );
  }
};

export const laborItem: IActionItem = {
  label: LABOR_PROTOKOLL_TITLE,
  route: '/' + LABOR_PROTOKOLL_PATH,
  svgIcon: MGS_LABOR_ICON,
  group: 'Dienstleistung',
  rolesForExclusion: laborRolesForExclusion,
  visibleFunc: ({ user, userRoles }: IActionContext) => user.laborDatenaustausch || isMgsAdmin(userRoles)
};

export const kidsPotentielleItem: IActionItem = {
  label: KIDS_TITLE,
  route: '/' + KIDS_PATH,
  svgIcon: MGS_USER_GROUP_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_KIDS]
};

export const kidsTermineItem: IActionItem = {
  label: KIDS_TERMINE_TITLE,
  route: '/' + KIDS_TERMINE_PATH,
  svgIcon: MGS_CALENDAR_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_KIDS]
};

export const kidsHotelItem: IActionItem = {
  label: KIDS_HOTELS_TITLE,
  route: '/' + KIDS_HOTELS_PATH,
  svgIcon: MGS_HOTEL_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_KIDS]
};

export const kidsImportItem: IActionItem = {
  label: KIDS_IMPORT_TITLE,
  route: '/' + KIDS_IMPORT_PATH,
  svgIcon: MGS_USER_GROUP_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_KIDS]
};

export const kidsTerminReservierungFaq: IActionItem = {
  label: 'Hilfe',
  action: (injector: Injector) => {
    const infoService = injector.get(KidsBuchungInfoService);
    infoService.faq();
  },
  svgIcon: MGS_FAQ_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_USER_FOR_KIDS_TERMIN]
};

export const kidsTerminReservierungImpressum: IActionItem = {
  label: 'Impressum',
  action: (injector: Injector) => {
    const infoService = injector.get(KidsBuchungInfoService);
    infoService.impressum();
  },
  svgIcon: MGS_DOCUMENT_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_USER_FOR_KIDS_TERMIN]
};

export const kidsTerminReservierungContact: IActionItem = {
  label: 'Kontakt',
  action: (injector: Injector) => {
    const infoService = injector.get(KidsBuchungInfoService);
    infoService.kontaktInformation();
  },
  svgIcon: MGS_CONTACT_ICON,
  group: 'Kids',
  roles: [ROLE_MGS_USER_FOR_KIDS_TERMIN]
};

// Achtung - die Reihenfolge der items hat Auswirkungen auf die Reihenfolgen der Gruppen die angezeigt werden...
export const dashboardItems: IActionItem[] = [
  codePruefungItem,
  dienstleistungItem,
  dienstleistungListItem,
  dienstleistungSchnellAbschlussItem,
  dienstleistungDatenerfassungItem,
  laborItem,
  fallPartnerDetailItem,
  leistungdefItem,
  leistungImporterItem,
  leistungItem,
  abrechnungenItem,
  partnerItem,
  userListItem,
  programmeItem,
  kundeListItem,
  adminServicesItem,
  auditlogServicesItem,
  kidsPotentielleItem,
  kidsTermineItem,
  kidsHotelItem,
  kidsImportItem,
  kidsTerminReservierungContact,
  kidsTerminReservierungImpressum,
  kidsTerminReservierungFaq,
  demoItem,
  dokumenteItem
];

export interface IActionContext {
  user: IUser;
  userRoles: string[];
  programme?: IGesundheitsProgrammInfo[];
  demoProgramme?: IGesundheitsProgrammInfo[];
}

export function createActionItems(context: IActionContext): IActionItem[] {
  const items = dashboardItems.filter((item) => {
    const roleMatch = !item.roles || item.roles.length === 0 || hasAnyRole(item.roles, context.userRoles);

    let result = roleMatch;

    if (result && item.visibleFunc) {
      result = item.visibleFunc(context);
    }

    if (result && item.rolesForExclusion?.length > 0 && hasAnyRole(item.rolesForExclusion, context.userRoles)) {
      result = false;
    }

    // console.log('actionItem ', item.label, 'result', result);

    return result;
  });

  return items;
}

export function createActionItemGroups(items: IActionItem[]): { [group: string]: IActionItem[] } {
  const itemGroups = createObjectArrayFromArray<IActionItem, IActionItem>(items, 'group');
  return itemGroups;
}
